<db-dialog-wrapper [dialog]="this" [width]="'1180px'" [fullScreen]="isMobile" [height]="'580px'" [canClose]="!loading" [hasCloseButton]="!loading"  [canCloseByBackdrop]="!loading">
  <div class="db-start-ai-builder" dbCustomScrollbar *ngIf="!firstStep">
    <db-recreate-website-steps [title]="'text_aiBuilder__stepTitle2' | dbText"  [fromDialog]="true" [websiteId]="websiteId"></db-recreate-website-steps>
  </div>

  <div class="db-recreate-website__steps"  *ngIf="firstStep" dbCustomScrollbar>
    <div class="db-recreate-website__page1">
      <h1>{{'text_aiBuilder__getting-started' | dbText}}</h1>
      <p>{{'text_aiBuilder__get-copy' | dbText}}</p>
      <div class="db-recreate-website__page1-content">
        <div class="db-recreate__page1-left"></div>
        <div class="db-recreate__page1-right">
          <div class="db-recreate__point">
            <i class="db-icon db-icon-checkbox-round"></i>
            <div>
              <div class="db-recreate__point-title"> {{'text_aiBuilder__move-to-wp' | dbText}} </div>
              <div class="db-recreate__point-desc" [innerHTML]="'text_aiBuilder__move-to-wp-desc' | dbText"> </div>
            </div>
          </div>
          <div class="db-recreate__point">
            <i class="db-icon db-icon-checkbox-round"></i>
            <div>
              <div class="db-recreate__point-title"> {{'text_aiBuilder__automated' | dbText}} </div>
              <div class="db-recreate__point-desc" [innerHTML]="'text_aiBuilder__automated-desc' | dbText"></div>
            </div>
          </div>
          <div class="db-recreate__point">
            <i class="db-icon db-icon-checkbox-round"></i>
            <div>
              <div class="db-recreate__point-title"> {{'text_aiBuilder__rapid' | dbText}} </div>
              <div class="db-recreate__point-desc" [innerHTML]="'text_aiBuilder__rapid-desc' | dbText"></div>
            </div>
          </div>
<!--          <div class="db-recreate__point">-->
<!--            <i class="db-icon db-icon-checkbox-round"></i>-->
<!--            <div>-->
<!--              <div class="db-recreate__point-title"> {{'text_aiBuilder__DIY' | dbText}} </div>-->
<!--              <div class="db-recreate__point-desc" [innerHTML]="'text_aiBuilder__DIY-desc' | dbText"></div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <a class="db-button db-button_lg db-button_info " (click)="nextStep()">
        <span *ngIf="!loading" >{{'text_aiBuilder__nextStep' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>

  </div>
</db-dialog-wrapper>
